import script from "./FraudAlertDetailDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./FraudAlertDetailDrawer.vue?vue&type=script&setup=true&lang=js"

import "./FraudAlertDetailDrawer.vue?vue&type=style&index=0&id=057a8a8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-057a8a8a"]])

export default __exports__